import { useNavigate } from "react-router-dom";
import '../../App.css';

export function TalentTableRow(props) {
    const navigate = useNavigate();
    const { object, index, cityList } = props;

    function onClick() {
        // 재능 마켓 상세 페이지로 이동 (registrationId 사용)
        const regId = object.registrationId;
        const url = `/talent_service/${regId}`;
        navigate(url);
    }

    // 지역 텍스트 처리 (원격 여부 확인)
    const getCityText = () => {
        // cityList에서 현재 object의 selectedCityId와 일치하는 도시명 찾기
        const city = cityList.find(c => c.id === object.selectedCityId);

        if (object.isRemote === 1) {
            return city ? `${city.cityName} | 온라인` : "온라인";
        }

        return city ? city.cityName : "지역무관";
    };

    // 가격 정보 포맷팅 (예: 50,000원 / HOUR)
    const getPriceText = () => {
        const unit = object.priceUnit === "HOUR" ? "시간당" :
            object.priceUnit === "ONCE" ? "회당" : "일당";

        if (Number(object.isPriceNegotiable) === 1) {
            return `가격협의 / ${unit}`;
        }

        const price = object.priceValue ? object.priceValue.toLocaleString() : "0";
        return `${price}유로 / ${unit}`;
    };

    return (
        <tr key={index} style={{ cursor: 'pointer' }} onClick={onClick}>
            {/* 1. 서비스 제목 */}
            <td class="priority-1" style={{ fontWeight: '500' }}>
                {object.title}
            </td>
            
            {/* 2. 카테고리 (재능 엔티티의 @JsonProperty("categoryName") 활용) */}
            <td class="priority-2" className="responsive-table-row">
                {object.categoryDisplayName || "미분류"}
            </td>
            
            {/* 3. 근무지/원격여부 */}
            <td class="priority-3" className="responsive-table-row">
                {getCityText()}
            </td>
            
            {/* 4. 가격 정보 */}
            <td class="priority-4" className="responsive-table-row">
                {getPriceText()}
            </td>
        </tr>
    );
}